import { Predicate } from "@siteimprove/alfa-predicate";
import { Parser } from "@siteimprove/alfa-parser";
import { Slice } from "@siteimprove/alfa-slice";
import { Array } from "@siteimprove/alfa-array";
import { Err, Ok } from "@siteimprove/alfa-result";
const { either, end, option, right, parseIf } = Parser;
/**
 * @public
 */
export var Autocomplete;
(function (Autocomplete) {
    /**
     * Autofill detail tokens from steps 2-4 of the list in {@link https://html.spec.whatwg.org/multipage/#autofill-detail-tokens}.
     */
    let AutofillDetailTokens;
    (function (AutofillDetailTokens) {
        AutofillDetailTokens.unmodifiables = [
            "name",
            "honorific-prefix",
            "given-name",
            "additional-name",
            "family-name",
            "honorific-suffix",
            "nickname",
            "username",
            "new-password",
            "current-password",
            "one-time-code",
            "organization-title",
            "organization",
            "street-address",
            "address-line1",
            "address-line2",
            "address-line3",
            "address-level4",
            "address-level3",
            "address-level2",
            "address-level1",
            "country",
            "country-name",
            "postal-code",
            "cc-name",
            "cc-given-name",
            "cc-additional-name",
            "cc-family-name",
            "cc-number",
            "cc-exp",
            "cc-exp-month",
            "cc-exp-year",
            "cc-csc",
            "cc-type",
            "transaction-currency",
            "transaction-amount",
            "language",
            "bday",
            "bday-day",
            "bday-month",
            "bday-year",
            "sex",
            "url",
            "photo",
        ];
        AutofillDetailTokens.modifiables = [
            "tel",
            "tel-country-code",
            "tel-national",
            "tel-area-code",
            "tel-local",
            "tel-local-prefix",
            "tel-local-suffix",
            "tel-extension",
            "email",
            "impp",
        ];
        AutofillDetailTokens.modifiers = ["home", "work", "mobile", "fax", "pager"];
        AutofillDetailTokens.addressTypes = ["shipping", "billing"];
        AutofillDetailTokens.webauthn = "webauthn";
    })(AutofillDetailTokens = Autocomplete.AutofillDetailTokens || (Autocomplete.AutofillDetailTokens = {}));
    /**
     * Checks if the provided string contains a valid autocomplete string according to {@link https://html.spec.whatwg.org/multipage/#autofill-detail-tokens}
     */
    Autocomplete.isValid = (autocomplete) => {
        // The following line comments each refers to the corresponding position in the HTML specification linked above at the time of writing
        const parse = right(option(section), // 1.
        right(option(addressType), // 2.
        right(
        // 3.
        either(unmodifiable, // 3.a
        right(option(modifier) /*3.b.1*/, modifiable /*3.b.2*/)), right(option(webauthn), // 4.
        end((token) => `Expected EOF, but got ${token}`)))));
        return parse(Slice.of(tokenize(autocomplete))).isOk();
    };
    function tokenize(autocomplete) {
        return Array.from(autocomplete.toLowerCase().trim().split(/\s+/));
    }
    Autocomplete.tokenize = tokenize;
    const parseFirst = (input) => input
        .first()
        .map((token) => Ok.of([input.rest(), token]))
        .getOr(Err.of("No token left"));
    function parserOf(tokens) {
        return parseIf((token) => tokens.includes(token), parseFirst, (token) => `Expected valid token, but got ${token}`);
    }
    const addressType = parserOf(AutofillDetailTokens.addressTypes);
    const unmodifiable = parserOf(AutofillDetailTokens.unmodifiables);
    const section = parseIf((token) => token.startsWith("section-"), parseFirst, (token) => `Expected token beginning with \`section-\`, but got ${token}`);
    const modifiable = parserOf(AutofillDetailTokens.modifiables);
    const modifier = parserOf(AutofillDetailTokens.modifiers);
    const webauthn = parserOf([AutofillDetailTokens.webauthn]);
})(Autocomplete || (Autocomplete = {}));
//# sourceMappingURL=autocomplete.js.map